<template>
    <div class="dropdown__relative-wrapper" :class="{ 'form-style' : formStyle }">
          <ul 
            class="dropdown" 
            :class="{'scrollable' : scrollable}"
            v-if="hasFocus" 
            ref="list-wrapper">
            <li 
              class="dropdown-item"
              :class="{ 
                'no-data': listItem.noResult,
                hovered: listItem == getSelectedItem}"
              v-for="(listItem, index) in value"
              :key="index"
              @click="toggleSelectedItem(listItem)"
              @mouseover="setHoveredItem(listItem, index)"
              :ref="`dropdown-item-${index}`"
            >
              {{ getLabel(listItem) }}
            </li>
          </ul>

        </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'


  export default {
    props: {
      value: [Object, Array, String],
      hasFocus: Boolean,
      scrollable: Boolean,
      hoveredItem: [Object, Array, String],
      formStyle: Boolean
    },

    data() {
      return {
        mouseHoverItem: ""
      }
    },

    methods: {
        getLabel(listItem) {
            return this.$parent.getLabel(listItem)
        },

        toggleSelectedItem(listItem) {
            this.$parent.toggleSelectedItem(listItem)
        },

        closeDropdown() {
          this.$parent.closeDropdown()
        },

        setHoveredItem(listItem, index) {
          let hovered = this.$refs[`dropdown-item-${index}`][0]
          let wrapper = this.$refs['list-wrapper']

          if(wrapper){
            wrapper.scrollBy(0, this.getYScroll(wrapper, hovered))
          }
          
          this.$emit("setHoverItem", listItem)
        },

        getYScroll(wrapper, item) {
          if(wrapper && item) {
            let wrapRect = wrapper.getBoundingClientRect()
            let hoverRect = item.getBoundingClientRect()
            let topScroll = hoverRect.top - wrapRect.top
            let bottomScroll = hoverRect.bottom - wrapRect.bottom 

            if(topScroll < 0) return topScroll
            if(bottomScroll > 0) return bottomScroll
          }

          return 0
        }

    },

    computed: {
      getSelectedItem() {
        return this.hoveredItem
      }
    },

    directives: {ClickOutside}

  }
</script>

<style lang="sass" scoped>
@import '../../../../styles/base/variables'


.dropdown__relative-wrapper
    position: relative

    &.form-style
      top: -15px

    .dropdown
      background: white
      width: 100%
      display: flex
      flex-direction: column
      position: absolute
      z-index: 10
      margin: 0
      border: 1px solid #e8e8e8;
      padding: 0

      &.scrollable
        overflow: auto
        max-height: 120px
        scrollbar-width: none

      &::-webkit-scrollbar 
        width: 0px;
        background: transparent

      .dropdown-item
        display: flex
        align-items: center
        justify-content: flex-start
        text-align: left
        width: 100%
        min-height: 32px
        padding: 0 8px

      .hovered
        background: $color-primary
        cursor: pointer
        color: white
      
      .no-data
        pointer-events: none
        background: white
</style>


// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/dropdown/DropdownList.vue